import React from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "@components/layout/footer/Footer";
import { Header } from "@components/Header";
import { ModalType, useModalStore } from "@hooks/stores/zustand-modal-store";
import { ModalClientLogin } from "@components/modals/modal-client-new";
import { ModalClientManagementIdentified } from "@components/modals/modal-client-management/identified";
import { ModalClientManagementVerified } from "@components/modals/modal-client-management/verified";

const PublicLayout: React.FC = () => {
  const { modals, closeModal } = useModalStore();

  // Function to render correct modal based on type
  const renderModal = (modal: { type: ModalType; props: any }) => {
    switch (modal.type) {
      case ModalType.MANAGEMENT_IDENTIFIED:
        return (
          <ModalClientManagementIdentified
            isOpen={true}
            onClose={() => closeModal(modal.type)}
          />
        );

      case ModalType.MANAGEMENT_VERIFIED:
        return (
          <ModalClientManagementVerified
            isOpen={true}
            onClose={() => closeModal(modal.type)}
          />
        );

      case ModalType.LOGIN:
        return (
          <ModalClientLogin
            isOpen={true}
            onClose={() => closeModal(modal.type)}
          />
        );

      default:
        return null;
    }
  };
  return (
    <>
      <Header onChange={() => {}} />

      <main>
        <Outlet />
      </main>

      <Footer />

      {/* Render all modals (stacked) */}
      {modals.map((modal, index) => (
        <div key={`${modal.type}-${index}`} style={{ zIndex: 1000 + index }}>
          {renderModal(modal)}
        </div>
      ))}
    </>
  );
};

export default PublicLayout;
